import { AuthService } from '@core/services/auth.service';
import { ProductMatrixService } from '@core/services/product-matrix.service';
import { QuestionService } from '../../../data/question.service';

import { NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { DefaultDialogBoxComponent } from '@shared/components/dialog-boxes/default-dialog-box/default-dialog-box.component';
import { ZubuchbarCardComponent } from '../../zubuchbar-card/zubuchbar-card.component';
import { ButtonService } from '../../../data/btn.services';
import { GeschaeftskontoComponent } from '../../geschaeftskonto/geschaeftskonto.component';
import { SeparatorComponent } from '@shared/components/separator/separator.component';
import { StepperComponent } from '../../stepper/stepper.component';
import { TranslationDirective } from '@shared/components/translata-modal/translation.directive';
import { QuestionTemplate } from '../question-template';
import { InfoCardComponent } from '@shared/components/info-card/info-card.component';
import { NatPerson } from '@core/models/user';
import { DialogService } from '@core/services/dialog.service';

@Component({
  selector: 'app-depot-bank-wahl',
  templateUrl: './depotbank-wahl.component.html',
  styleUrls: ['./depotbank-wahl.component.scss'],
  imports: [
    TranslationDirective,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    SeparatorComponent,
    GeschaeftskontoComponent,
    ZubuchbarCardComponent,
    StepperComponent,
    NgIf,
    NgFor,
  ],
})
export class DepotbankWahlComponent extends QuestionTemplate implements OnInit {
  selectedBank: string;
  berufsGruppe: any;
  enableTagesgeldkonto: any;
  isSelectLiquid: boolean;

  constructor(
    auth: AuthService,
    questionService: QuestionService,
    route: ActivatedRoute,
    public btnService: ButtonService,
    public productMatrixService: ProductMatrixService,
    public dialog: DialogService
  ) {
    super(auth, questionService, route);
    this.questionName = 'bank-wahl';
  }

  override ngOnInit(): void {
    this.berufsGruppe = this.auth.getBerufsGruppe();
    this.isSelectLiquid = this.checkIsSelectLiquid(this.auth.user.natPersonen);
    super.ngOnInit();
    this.createFormGroup();
    this.setupAbtretungsvertragBehavior();
    this.loadValues();

    this.auth.getConfig().subscribe({
      next: (response) => {
        this.enableTagesgeldkonto = response?.data?.enableTagesgeldkonto ?? false;
      },
    });
  }

  public checkIsSelectLiquid(natPersonen?: NatPerson[]): boolean {
    return this.auth.isSelectLiquid(natPersonen);
  }

  private createFormGroup(): void {
    const abtretungsvertragValidators = this.hasAbtretung() ? [Validators.required] : [];

    this.answerFormGroup = new FormGroup({
      geschäftKonto: new FormControl({ value: true, disabled: true }, [Validators.required]),
      tagesgeldkonto: new FormControl({ value: true, disabled: true }, [Validators.required]),
      selectLiquidSichtkonto: new FormControl({ value: true, disabled: true }, [Validators.required]),
      kontokorrentkredit: new FormControl(true),
      abtretungsvertrag: new FormControl({ value: false, disabled: true }, abtretungsvertragValidators),
      kontoWechselService: new FormControl(true),
      girocard: new FormControl({ value: true, disabled: true }, [Validators.required]),
      onlineBanking: new FormControl({ value: true, disabled: true }, [Validators.required]),
      elektronischesPostfach: new FormControl({ value: true, disabled: true }, [Validators.required]),
      firmenlastschrift: new FormControl({ value: true, disabled: true }, [Validators.required]),
    });
  }

  private setupAbtretungsvertragBehavior(): void {
    if (!this.hasAbtretung()) {
      return;
    }

    this.answerFormGroup.get('abtretungsvertrag')!.disable();
  }

  onKontokorrentkreditChange(event: any): void {
    if (this.hasAbtretung() && !event.checked) {
      this.answerFormGroup.controls['abtretungsvertrag'].setValue(false);
    }
  }

  showWarningMessage(): boolean {
    if (this.hasAbtretung()) {
      const kontokorrentkredit = this.answerFormGroup.get('kontokorrentkredit')?.value;
      const abtretungsvertrag = this.answerFormGroup.get('abtretungsvertrag')?.value;
      return kontokorrentkredit && !abtretungsvertrag;
    }
    return false;
  }

  hasAbtretung() {
    return this.berufsGruppe?.abtretung === true;
  }
}
